<template>
  <div class="gallery-grid js-results-grid">
    <div class="gallery-grid__items">
      <div
        v-for="result in results"
        :key="`${result.name}-${result.id}`"
        class="gallery-grid__item-wrapper"
        data-micromodal-trigger="modal-gallery-project"
      >
        <a @click="handleProjectClick(result)">
          <div class="gallery-grid__img-wrap">
            <img class="gallery-grid__item" :src="thumbnailImg(result)" />
          </div>
          <div class="gallery-grid__item-info">
            <div
              class="gallery-grid__item-variant-name font-light leading-normal "
            >
              <span v-if="!!result.industry" class="label--line">{{
                result.industry | capitalizeAll
              }}</span>
              <span v-if="!result.industry">&nbsp;</span>
            </div>
            <div class="gallery-grid__item-parent-name mt-2">
              {{ result.name }}
            </div>
          </div>
        </a>
      </div>
    </div>
    <NoResultsOrError
      v-if="results.length === 0 && !loadingData"
      :results="results"
      :apiCallMade="apiCallMade"
      :error="error"
      :no-results-message="noResultsMessage"
      :no-results-redirect="noResultsRedirect"
      :no-results-redirect-text="noResultsRedirectText"
      :no-results-open-chat="noResultsOpenChat"
    />
  </div>
</template>

<script>
import NoResultsOrError from '../shared/NoResultsOrError';
import { eventBus } from '../shared/event-bus';

const basePathsByType = {
  GraphicPattern: '/graphic-patterns/:parentName/:variantName/:color',
  ColorType: '/color/:variantName',
};

export default {
  name: 'GalleryResultsGrid',
  components: {
    NoResultsOrError,
  },
  props: [
    'results',
    'error',
    'apiCallMade',
    'currentPage',
    'galleryProjectModalId',
    'totalResults',
    'perPage',
    'totalPages',
    'noResultsMessage',
    'noResultsRedirect',
    'noResultsRedirectText',
    'noResultsOpenChat',
    'loadingData',
  ],
  data() {
    return {
      maxVariantsToDisplay: 5,
      noBackgroundColorTypes: ['ColorType', 'Interlayer'],
      noGradientTypes: ['ColorType'],
    };
  },
  methods: {
    linkURL(projecId) {
      return `${window.location.origin}/gallery/${projecId}`;
    },
    handleProjectClick(project) {
      eventBus.updateSelectedGalleryProject(project);
    },
    thumbnailImg(result) {
      return `https://img.imageboss.me/cover:center/600x480/${result.thumbnail}`;
    },
  },
};
</script>
